import { PageType, defaultLanguage } from '@stereoagency/constants';
import { page } from '@stereoagency/sanity-schema';
import { $globalSanityClient } from '@/sanity';
import { SpecialPagesContextValue } from '@/components/context';
import { createDocumentURL } from '@/utils';

const pagesQuery = page.schema.builder
  .filter(`pageType != "${PageType.CONTENT_PAGE}"`)
  .pick(['_id', 'pageType', 'slug', 'language', 'title'])
  .use();

export default async function fetchSpecialPages(lang: string) {
  const allPages = await $globalSanityClient.fetch<(typeof pagesQuery)[1]>(
    pagesQuery[0]
  );

  const pages: SpecialPagesContextValue['pages'] = {
    [PageType.EVENT_LISTING_PAGE]: null,
    [PageType.HOMEPAGE]: null,
    [PageType.JOB_LISTING_PAGE]: null,
    [PageType.NEWS_LISTING_PAGE]: null,
    [PageType.RESEARCH_GROUP_LISTING_PAGE]: null,
    [PageType.RESEARCH_PLATFORM_LISTING_PAGE]: null
  };

  Object.values(PageType).forEach((pageType) => {
    if (pageType !== PageType.CONTENT_PAGE) {
      const foundPage =
        allPages.find((p) => p.pageType === pageType && p.language === lang) ??
        allPages.find(
          (p) => p.pageType === pageType && p.language === defaultLanguage.id
        ) ??
        null;
      if (foundPage?.slug?.current) {
        pages[pageType] = {
          _id: foundPage._id,
          href: createDocumentURL(lang, 'page', foundPage.slug.current),
          title: foundPage.title ?? ''
        };
      }
    }
  });

  return { pages };
}
